import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/layout'

/**
 * affix: true，TagsView标签常显
 * noCache: true, 页面不缓存
 * name字段与各页面中name字段需一致，KeepAlive才能生效
 */

const routes = [
  {
    path: '/',
    component: () => import('@/views/login'),
    meta: { title: '登陆' },
  },

  //首页
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', affix: true }
      }
    ]
  },

  //信息审核
  {
    path: '/review',
    component: Layout,
    redirect: '/review/resume',
    children: [
      {
        path: 'resume',
        component: () => import('@/views/review/resume'),
        name: 'ReviewResume',
        meta: { title: '信息审核'}
      },
      {
        path: 'identity',
        component: () => import('@/views/review/identity'),
        name: 'ReviewIdentity',
        meta: { title: '身份证审核'}
      },
      {
        path: 'identity-fast',
        component: () => import('@/views/review/identity-fast'),
        name: 'ReviewIdentityFast',
        meta: { title: '身份证快审'}
      },
      {
        path: 'photos',
        component: () => import('@/views/review/photos'),
        name: 'ReviewPhotos',
        meta: { title: '相册审核'}
      },
      {
        path: 'other',
        component: () => import('@/views/review/other'),
        name: 'ReviewOther',
        meta: { title: '其他审核项'}
      },
      // {
      //   path: 'withdrawal',
      //   component: () => import('@/views/review/withdrawal'),
      //   name: 'ReviewWithdrawal',
      //   meta: { title: '提现审核'}
      // }
    ]
  },
  //
  //金币
  {
    path: '/gold',
    component: Layout,
    redirect: '/gold/price',
    children: [
      {
        path: 'price',
        component: () => import('@/views/gold/price'),
        name: 'GoldPrice',
        meta: { title: '金币管理'}
      },
      {
        path: 'detail',
        component: () => import('@/views/gold/detail'),
        name: 'GoldDetail',
        meta: { title: '金币账单明细'}
      }
    ]
  },

  // //积分
  // {
  //   path: '/integral',
  //   component: Layout,
  //   redirect: '/integral/detail',
  //   children: [
  //     {
  //       path: 'detail',
  //       component: () => import('@/views/integral/detail'),
  //       name: 'IntegralDetail',
  //       meta: { title: '积分明细'}
  //     }
  //   ]
  // },

  //礼物
  {
    path: '/gift',
    component: Layout,
    redirect: '/gift/manage',
    children: [
      {
        path: 'manage',
        name: 'GiftManage',
        component: () => import('@/views/gift/manage'),
        meta: { title: '礼物管理'}
      }
    ]
  },

  //背景图片
  {
    path: '/back-ground',
    component: Layout,
    redirect: '/back-ground/manage',
    children: [
      {
        path: 'manage',
        name: 'BackGround',
        component: () => import('@/views/back-ground/manage'),
        meta: { title: '背景图配置'}
      }
    ]
  },

  //意见举报
  {
    path: '/feedback',
    component: Layout,
    redirect: '/feedback/opinion',
    children: [
      {
        path: 'opinion',
        component: () => import('@/views/feedback/opinion'),
        name: 'FeedbackOpinion',
        meta: { title: '意见反馈'}
      },
      {
        path: 'report',
        component: () => import('@/views/feedback/report'),
        name: 'FeedbackReport',
        meta: { title: '举报管理'}
      },
      {
        path: 'illegal',
        component: () => import('@/views/feedback/illegal'),
        name: 'FeedbackIllegal',
        meta: { title: '违规通报'}
      }
    ]
  },
  //
  // //奖励
  // {
  //   path: '/reward',
  //   component: Layout,
  //   redirect: '/reward/manage',
  //   children: [
  //     {
  //       path: 'manage',
  //       name: 'RewardManage',
  //       component: () => import('@/views/reward/manage'),
  //       meta: { title: '奖励管理'}
  //     }
  //   ]
  // },
  //
  //渠道/版本管理
  {
    path: '/channel',
    component: Layout,
    redirect: '/channel/version',
    children: [
      {
        path: 'version',
        name: 'ChannelVersion',
        component: () => import('@/views/channel/version'),
        meta: { title: '版本管理'}
      },
      {
        path: 'control',
        name: 'ChannelControl',
        component: () => import('@/views/channel/control'),
        meta: { title: '产品方案渠道控制'}
      },
      {
        path: 'index',
        name: 'ChannelIndex',
        component: () => import('@/views/channel/index'),
        meta: { title: '渠道信息'}
      },
      {
        path: 'package',
        name: 'ChannelPackage',
        component: () => import('@/views/channel/package'),
        meta: { title: '包名信息'}
      }
    ]
  },
  //
  //数据管理
  {
    path: '/data',
    component: Layout,
    redirect: '/data/vip-open',
    children: [
      // {
      //   path: 'statistics',
      //   component: () => import('@/views/data/statistics'),
      //   name: 'DataStatistics',
      //   meta: { title: '数据统计'}
      // },
      {
        path: 'vip-open',
        component: () => import('@/views/data/vip-open'),
        name: 'DataVipOpen',
        meta: { title: 'vip开通数据'}
      },
      {
        path: 'star-open',
        component: () => import('@/views/data/star-open'),
        name: 'DataStarOpen',
        meta: { title: 'SVIP开通数据'}
      },
      {
        path: 'abnormal-order',
        component: () => import('@/views/data/abnormal-order'),
        name: 'DataAbnormalOrder',
        meta: { title: '异常订单号'}
      },
      {
        path: 'recommend',
        component: () => import('@/views/data/recommend'),
        name: 'DataRecommend',
        meta: { title: '推荐统计'}
      }
    ]
  },

  //系统管理
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/sys-model',
    children: [
      {
        path: 'sys-model',
        component: () => import('@/views/setting/sys-model'),
        name: 'SysModel',
        meta: { title: '后台目录'}
      },
      {
        path: 'sys-admin',
        component: () => import('@/views/setting/sys-admin'),
        name: 'SysAdmin',
        meta: { title: '用户权限'}
      },
      {
        path: 'sys-param',
        component: () => import('@/views/setting/sys-param'),
        name: 'SysParam',
        meta: { title: '系统参数'}
      },
      {
        path: 'test-account',
        component: () => import('@/views/setting/test-account'),
        name: 'TestAccount',
        meta: { title: '测试账号'}
      },
      {
        path: 'recommend-param',
        component: () => import('@/views/setting/recommend-param'),
        name: 'RecommendParam',
        meta: { title: '推荐参数'}
      },
      {
        path: 'recommend-param-home',
        component: () => import('@/views/setting/recommend-param-home'),
        name: 'RecommendParamHome',
        meta: { title: '筛选推荐参数'}
      },
      {
        path: 'invitation-param',
        component: () => import('@/views/setting/invitation-param'),
        name: 'InvitationParam',
        meta: { title: '邀请制配置'}
      },
      {
        path: 'alipay',
        component: () => import('@/views/setting/alipay'),
        name: 'Alipay',
        meta: { title: '阿里账号'}
      },
      {
        path: 'wechat',
        component: () => import('@/views/setting/wechat'),
        name: 'Wechat',
        meta: { title: '微信支付配置'}
      },
      {
        path: 'auxiliary',
        component: () => import('@/views/setting/auxiliary'),
        name: 'Auxiliary',
        meta: { title: '运营辅助'}
      }
    ]
  },
  //
  // //果购城微信管理
  // {
  //   path: '/guogou',
  //   component: Layout,
  //   redirect: '/guogou/wechat',
  //   children: [
  //     {
  //       path: 'wechat',
  //       name: 'GgWechat',
  //       component: () => import('@/views/guogou/wechat'),
  //       meta: { title: '果购城微信管理'}
  //     }
  //   ]
  // },
  //
  //信息标签
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/tag',
    children: [
      {
        path: 'tag',
        name: 'SysTag',
        component: () => import('@/views/sys/tag'),
        meta: { title: '信息标签（注册）'}
      },
      {
        path: 'nick-name',
        name: 'SysNickName',
        component: () => import('@/views/sys/nick-name'),
        meta: { title: '系统默认昵称'}
      },
      {
        path: 'head',
        name: 'SysHeadImg',
        component: () => import('@/views/sys/head'),
        meta: { title: '头像管理'}
      },
      {
        path: 'warm-tip',
        name: 'SysWarmTip',
        component: () => import('@/views/sys/warm-tip'),
        meta: { title: '温馨提示'}
      },
      {
        path: 'question',
        name: 'SysQuestion',
        component: () => import('@/views/sys/question'),
        meta: { title: '问题集'}
      },
      {
        path: 'tag-info',
        name: 'SysTagInfo',
        component: () => import('@/views/sys/tag-info'),
        meta: { title: '信息标签（主页）'}
      },
      {
        path: 'through-code',
        name: 'SysThroughCode',
        component: () => import('@/views/sys/through-code'),
        meta: { title: '通过码-入口权限管理'}
      },
      {
        path: 'ad',
        name: 'SysAd',
        component: () => import('@/views/sys/ad'),
        meta: { title: '广告配置'}
      }
    ]
  },

  //聊天管理
  {
    path: '/chat',
    component: Layout,
    redirect: '/chat/greeting',
    children: [
      {
        path: 'greeting',
        name: 'ChatGreeting',
        component: () => import('@/views/chat/greeting'),
        meta: { title: '快捷问候语'}
      },
      {
        path: 'content',
        name: 'ChatContent',
        component: () => import('@/views/chat/content'),
        meta: { title: '聊天内容'}
      },
      {
        path: 'monitor',
        name: 'ChatMonitor',
        component: () => import('@/views/chat/monitor'),
        meta: { title: '聊天内容监控'}
      },
      {
        path: 'black-rule',
        name: 'BlackRule',
        component: () => import('@/views/chat/black-rule'),
        meta: { title: '黑名单词库'}
      },
      {
        path: 'push',
        name: 'ChatPush',
        component: () => import('@/views/chat/push'),
        meta: { title: '推送管理'}
      },
      {
        path: 'violation',
        name: 'ChatViolation',
        component: () => import('@/views/chat/violation'),
        meta: { title: '聊天触发'}
      }
    ]
  },

  //vip管理
  {
    path: '/vip',
    component: Layout,
    redirect: '/vip/sets',
    children: [
      {
        path: 'sets',
        name: 'VipSets',
        component: () => import('@/views/vip/sets'),
        meta: { title: 'VIP套餐管理'}
      },
      {
        path: 'user',
        name: 'VipUser',
        component: () => import('@/views/vip/user'),
        meta: { title: 'VIP用户管理'}
      },
      {
        path: 'privilege',
        name: 'VipPrivilege',
        component: () => import('@/views/vip/privilege'),
        meta: { title: '会员特权管理'}
      }
    ]
  },

  //婚恋服务
  {
    path: '/marriage',
    component: Layout,
    redirect: '/marriage/sets',
    children: [
      {
        path: 'sets',
        name: 'MarriageSets',
        component: () => import('@/views/marriage/sets'),
        meta: { title: 'SVIP套餐管理'}
      },
      {
        path: 'expire',
        name: 'MarriageExpire',
        component: () => import('@/views/marriage/expire'),
        meta: { title: 'SVIP用户管理'}
      },
      {
        path: 'matcher',
        name: 'MarriageMatcher',
        component: () => import('@/views/marriage/matcher'),
        meta: { title: '牵线服务'}
      }
    ]
  },

  //用户管理
  {
    path: '/user',
    component: Layout,
    redirect: '/user/list',
    children: [
      {
        path: 'list',
        name: 'UserList',
        component: () => import('@/views/user/list'),
        meta: { title: '用户名单'}
      },
      {
        path: 'top',
        name: 'UserTop',
        component: () => import('@/views/user/top'),
        meta: { title: '用户置顶'}
      },
      {
        path: 'enter-free',
        name: 'EnterFree',
        component: () => import('@/views/user/enter-free'),
        meta: { title: '免费进入'}
      },
      {
        path: 'enter-check',
        name: 'EnterCheck',
        component: () => import('@/views/user/enter-check'),
        meta: { title: '审核版检查'}
      },
      {
        path: 'emulator',
        name: 'Emulator',
        component: () => import('@/views/user/emulator'),
        meta: { title: '设备登录信息'}
      }
    ]
  },

  //认证管理
  {
    path: '/auth',
    component: Layout,
    redirect: '/auth/job',
    children: [
      {
        path: 'job',
        name: 'AuthJob',
        component: () => import('@/views/auth/job'),
        meta: { title: '职业认证'}
      },
      {
        path: 'education',
        name: 'AuthEducation',
        component: () => import('@/views/auth/education'),
        meta: { title: '学历认证'}
      },
      {
        path: 'car',
        name: 'AuthCar',
        component: () => import('@/views/auth/car'),
        meta: { title: '车辆认证'}
      },
      {
        path: 'house',
        name: 'AuthHouse',
        component: () => import('@/views/auth/house'),
        meta: { title: '房产认证'}
      },
      {
        path: 'video',
        name: 'AuthVideo',
        component: () => import('@/views/auth/video'),
        meta: { title: '视频认证'}
      }
    ]
  },

  //打招呼: 互动数据
  {
    path: '/greeting',
    component: Layout,
    redirect: '/greeting/initiator',
    children: [
      {
        path: 'initiator',
        name: 'GreetingInitiator',
        component: () => import('@/views/greeting/initiator'),
        meta: { title: '发起方'}
      },
      {
        path: 'receiver',
        name: 'GreetingReceiver',
        component: () => import('@/views/greeting/receiver'),
        meta: { title: '接收方'}
      },
      {
        path: 'review',
        name: 'GreetingReview',
        component: () => import('@/views/greeting/review'),
        meta: { title: '沟通用语-打招呼'}
      }
    ]
  },

  //微信管理
  {
    path: '/wechat',
    component: Layout,
    redirect: '/wechat/review',
    children: [
      {
        path: 'review',
        name: 'WeChatReview',
        component: () => import('@/views/wechat/review'),
        meta: { title: '微信审核'}
      },
      {
        path: 'marriage',
        name: 'WeChatMarriage',
        component: () => import('@/views/wechat/marriage'),
        meta: { title: '红娘微信管理'}
      },
      {
        path: 'through-code',
        name: 'WeChatThroughCode',
        component: () => import('@/views/wechat/through-code'),
        meta: { title: '红娘微信-通过码处展示'}
      },
      {
        path: 'record',
        name: 'WeChatRecord',
        component: () => import('@/views/wechat/record'),
        meta: { title: '微信下载记录'}
      }
    ]
  },

  //红娘管理
  {
    path: '/matcher',
    component: Layout,
    redirect: '/matcher/msg',
    children: [
      {
        path: 'msg',
        name: 'MatcherMsg',
        component: () => import('@/views/matcher/msg'),
        meta: { title: '红娘消息管理'}
      },
      {
        path: 'sms',
        name: 'MatcherSms',
        component: () => import('@/views/matcher/sms'),
        meta: { title: '红娘短信管理'}
      }
    ]
  },

  //banner管理
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/vip',
    children: [
      {
        path: 'vip',
        name: 'BannerVip',
        component: () => import('@/views/banner/vip'),
        meta: { title: 'vip服务页面banner'}
      },
      {
        path: 'home',
        name: 'BannerHome',
        component: () => import('@/views/banner/home'),
        meta: { title: '首页banner图'}
      },
      {
        path: 'icon',
        name: 'BannerIcon',
        component: () => import('@/views/banner/icon'),
        meta: { title: '首页图标入口'}
      },
      {
        path: 'discovery',
        name: 'BannerDiscovery',
        component: () => import('@/views/banner/discovery'),
        meta: { title: 'Banner管理'}
      },
    ]
  },

  //IP访问记录
  {
    path: '/ip',
    component: Layout,
    redirect: '/ip/visit',
    children: [
      {
        path: 'visit',
        name: 'IpVisit',
        component: () => import('@/views/ip/visit'),
        meta: { title: 'IP访问记录'}
      },
    ]
  },

  //图片信息编辑
  {
    path: '/img',
    component: Layout,
    redirect: '/img/info',
    children: [
      {
        path: 'info',
        name: 'InfoImgList',
        component: () => import('@/views/img/info'),
        meta: { title: '图片信息编辑'}
      },
    ]
  },

  //一对一服务、脱单圈
  {
    path: '/single',
    component: Layout,
    redirect: '/single/service',
    children: [
      {
        path: 'service',
        name: 'SingleService',
        component: () => import('@/views/single/service'),
        meta: { title: '脱单服务'}
      },
      {
        path: 'sign-up',
        name: 'SingleSignUp',
        component: () => import('@/views/single/sign-up'),
        meta: { title: '报名列表'}
      },
      {
        path: 'release',
        name: 'SingleRelease',
        component: () => import('@/views/single/release'),
        meta: { title: '脱单圈发布'}
      },
      {
        path: 'examine',
        name: 'SingleExamine',
        component: () => import('@/views/single/examine'),
        meta: { title: '脱单圈审核'}
      },
    ]
  },

  //评分管理
  {
    path: '/score',
    component: Layout,
    redirect: '/score/manage',
    children: [
      {
        path: 'manage',
        name: 'ScoreManage',
        component: () => import('@/views/score/manage'),
        meta: { title: '评分管理'}
      },
    ]
  },

  //短信管理
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/verify',
    children: [
      {
        path: 'verify',
        name: 'SmsVerify',
        component: () => import('@/views/sms/verify'),
        meta: { title: '短信管理'}
      },
      {
        path: 'activation',
        name: 'SmsActivation',
        component: () => import('@/views/sms/activation'),
        meta: { title: '激活短信管理'}
      },
      {
        path: 'sign',
        name: 'SmsSign',
        component: () => import('@/views/sms/sign'),
        meta: { title: '渠道短信签名'}
      },
    ]
  },

  //三行情书
  {
    path: '/love',
    component: Layout,
    redirect: '/love/msg',
    children: [
      {
        path: 'msg',
        name: 'LoveMsg',
        component: () => import('@/views/love/msg'),
        meta: { title: '留言管理'}
      },
      {
        path: 'letter',
        name: 'LoveLetter',
        component: () => import('@/views/love/letter'),
        meta: { title: '三行情书'}
      },
      {
        path: 'submit',
        name: 'LoveSubmit',
        component: () => import('@/views/love/submit'),
        meta: { title: '投稿管理'}
      },
    ]
  },

  // //语音管理
  // {
  //   path: '/voice',
  //   component: Layout,
  //   redirect: '/voice/reference',
  //   children: [
  //     {
  //       path: 'reference',
  //       name: 'VoiceReference',
  //       component: () => import('@/views/voice/reference'),
  //       meta: { title: '语音参考内容'}
  //     },
  //     {
  //       path: 'review',
  //       name: 'VoiceReview',
  //       component: () => import('@/views/voice/review'),
  //       meta: { title: '语音审核'}
  //     }
  //   ]
  // },
  //
  //动态管理
  {
    path: '/dynamic',
    component: Layout,
    redirect: '/dynamic/review',
    children: [
      {
        path: 'review',
        name: 'DynamicReview',
        component: () => import('@/views/dynamic/review'),
        meta: { title: '动态管理'}
      },
      {
        path: 'interact',
        name: 'DynamicInteract',
        component: () => import('@/views/dynamic/interact'),
        meta: { title: '动态互动管理'}
      },
      {
        path: 'topic',
        name: 'DynamicTopic',
        component: () => import('@/views/dynamic/topic'),
        meta: { title: '话题管理'}
      },
      {
        path: 'official',
        name: 'DynamicOfficial',
        component: () => import('@/views/dynamic/official'),
        meta: { title: '官方动态'}
      },
      {
        path: 'official-interact',
        name: 'DynamicOfficialInteract',
        component: () => import('@/views/dynamic/official-interact'),
        meta: { title: '官方动态互动'}
      }
    ]
  },

  //用户邀请
  {
    path: '/invite',
    component: Layout,
    redirect: '/invite/img',
    children: [
      // {
      //   path: 'detail',
      //   name: 'InviteDetail',
      //   component: () => import('@/views/invite/detail'),
      //   meta: { title: '用户邀请'}
      // }
      {
        path: 'img',
        name: 'InviteImg',
        component: () => import('@/views/invite/img'),
        meta: { title: '邀请图片'}
      },
      {
        path: 'search',
        name: 'InviteSearch',
        component: () => import('@/views/invite/search'),
        meta: { title: '邀请码搜索'}
      }
    ]
  },
  //
  // //ios审核
  // {
  //   path: '/ios-review',
  //   component: Layout,
  //   redirect: '/ios-review/scrip',
  //   children: [
  //     {
  //       path: 'scrip',
  //       name: 'IosReviewScrip',
  //       component: () => import('@/views/ios-review/scrip'),
  //       meta: { title: '纸条管理'}
  //     },
  //     {
  //       path: 'emotion',
  //       name: 'IosReviewEmotion',
  //       component: () => import('@/views/ios-review/emotion'),
  //       meta: { title: '情感广场'}
  //     }
  //   ]
  // },

  //活跃达人
  {
    path: '/talent',
    component: Layout,
    redirect: '/talent/apply',
    children: [
      {
        path: 'apply',
        name: 'TalentApply',
        component: () => import('@/views/talent/apply'),
        meta: { title: '达人审核'}
      },
      {
        path: 'integral',
        name: 'TalentIntegral',
        component: () => import('@/views/talent/integral'),
        meta: { title: '达人积分统计'}
      },
      {
        path: 'award',
        name: 'TalentAward',
        component: () => import('@/views/talent/award'),
        meta: { title: '达人提现'}
      },
      {
        path: 'prize',
        name: 'TalentPrize',
        component: () => import('@/views/talent/prize'),
        meta: { title: '达人奖品'}
      },
      {
        path: 'integral-rule',
        name: 'IntegralRule',
        component: () => import('@/views/talent/integral-rule'),
        meta: { title: '积分奖励管理'}
      }
    ]
  },

  //互动管理
  {
    path: '/interact',
    component: Layout,
    redirect: '/interact/msg',
    children: [
      {
        path: 'msg',
        name: 'InteractMsg',
        component: () => import('@/views/interact/msg'),
        meta: { title: '纸条审核'}
      },
      {
        path: 'pair',
        name: 'InteractPair',
        component: () => import('@/views/interact/pair'),
        meta: { title: '配对列表'}
      },

    ]
  },

  //代金券
  {
    path: '/voucher',
    component: Layout,
    redirect: '/voucher/sys',
    children: [
      {
        path: 'sys',
        name: 'VoucherSys',
        component: () => import('@/views/voucher/sys'),
        meta: { title: '代金券管理'}
      },
    ]
  },

  //专区管理
  {
    path: '/special',
    component: Layout,
    redirect: '/special/manage',
    children: [
      {
        path: 'manage',
        name: 'SpecialManage',
        component: () => import('@/views/special/manage'),
        meta: { title: '专区管理'}
      },
    ]
  },

  //任务管理
  {
    path: '/task',
    component: Layout,
    redirect: '/task/manage',
    children: [
      {
        path: 'manage',
        name: 'TaskManage',
        component: () => import('@/views/task/manage'),
        meta: { title: '任务管理'}
      },
    ]
  },

  //地区管理
  {
    path: '/area',
    component: Layout,
    redirect: '/area/city',
    children: [
      {
        path: 'city',
        name: 'AreaCity',
        component: () => import('@/views/area/city'),
        meta: { title: '先逛逛城市管理'}
      },
    ]
  },

  //保证金返还
  {
    path: '/fee',
    component: Layout,
    redirect: '/fee/deposit',
    children: [
      {
        path: 'deposit',
        name: 'FeeDeposit',
        component: () => import('@/views/fee/deposit'),
        meta: { title: '保证金返还'}
      },
    ]
  },

  //成功案例
  {
    path: '/success',
    component: Layout,
    redirect: '/success/case',
    children: [
      {
        path: 'case',
        name: 'SuccessCase',
        component: () => import('@/views/success/case'),
        meta: { title: '成功案例管理'}
      },
      {
        path: 'msg',
        name: 'SuccessMsg',
        component: () => import('@/views/success/msg'),
        meta: { title: '文章留言管理'}
      },
    ]
  },

  //第三方
  {
    path: '/third',
    component: Layout,
    redirect: '/third/settlement',
    children: [
      {
        path: 'settlement',
        name: 'ThirdSettlement',
        component: () => import('@/views/third/settlement'),
        meta: { title: '渠道商结算'}
      },
      {
        path: 'queqiaohui',
        name: 'ThirdQueqiaohui',
        component: () => import('@/views/third/queqiaohui'),
        meta: { title: '慈海鹊桥会'}
      },
      {
        path: 'blind-date',
        name: 'ThirdBlindDate',
        component: () => import('@/views/third/blind-date'),
        meta: { title: '新相亲大会'}
      },
    ]
  },


]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const nextRoute = JSON.parse(sessionStorage.getItem('navArray'));
  // console.log(nextRoute)
  if(to.path != '/home/index' && to.path != '/') {
    if (nextRoute == null || nextRoute.indexOf(to.path) == -1) {
      next({path: '/'})
    }
  }
  next()
})

export default router
